import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../../../../shared/_services/validation.service';
import { UserManagementService } from '../../../../../shared/_services/user-management.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-management-add',
  templateUrl: './user-management-add.component.html',
  styleUrls: ['./user-management-add.component.scss']
})
export class UserManagementAddComponent implements OnInit {
  errorDetails: any;

  user: any = FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private validationService: ValidationService,
    private userManagementService: UserManagementService
  ) { }
  
  ngOnInit() {
    this.user = this.fb.group({
      // email: ['', Validators.compose([Validators.required, Validators.pattern(this.validationService.email_regexPattern)])],
      email: ['', Validators.compose([Validators.required])],
      firstName: ['', Validators.required],
      lastName1: ['', Validators.required],
      // mobileNumber: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(12), Validators.pattern(this.validationService.phoneNumber_regexPattern)])],
      mobileNumber: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(15)])],
      password: [''],
      newPassword:['']
    });
  }
  
  saveUserInfo(data) {
    data.value.userRoleId = 11;
    let formData: any = new FormData()
    formData.append('user', JSON.stringify(data.value));
    console.log(data.value);
    //var file = new File([], null, { type: 'image/jpg' });
    var file = new Blob([], { type: 'image/jpg' });
    formData.append('profilePic', file, null);
    this.userManagementService.profileUpdate(formData, true).subscribe((res) => {
      if(res.error == 0) {
        this.router.navigate(['/user-management']);
      } else {
        this.errorDetails = res.message;
      }
    }, error => {
      console.log('========res ===========', error);
      this.errorDetails = error.message;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/user-management/user-management-add/user-management-add.component.ts